import React, { memo } from 'react'
import { GrClose } from 'react-icons/gr'
import { useHistory } from 'react-router-dom'
import Button from 'shared/components/Button'
import Text from 'shared/components/Text'
import { colors } from 'shared/styles/colors'
import intersect from 'shared/assets/images/intersect.png'

import { Container } from '../../Pagamento/styles'
import {
  ContainerIcon,
  ContainerContent,
  ContainerButton,
  StyledModal,
} from './styles'
interface IModalContaRejeitadaProps {
  openModalContaRejeitada: boolean
  setOpenModalContaRejeitada(state: boolean): void
  openModalSelectCnpj(): void
  clerSelectedFrotista(): void
}

const ModalContaRejeitada = ({
  openModalContaRejeitada,
  setOpenModalContaRejeitada,
  openModalSelectCnpj,
  clerSelectedFrotista,
}: IModalContaRejeitadaProps) => {
  const history = useHistory()

  return (
    <>
      <StyledModal
        img={intersect}
        openModal={openModalContaRejeitada}
        size="small"
        showCloseButton={true}
        onCloseModal={() => {
          setOpenModalContaRejeitada(false)
          clerSelectedFrotista()
          openModalSelectCnpj()
        }}
      >
        <Container>
          <ContainerIcon>
            <GrClose />
          </ContainerIcon>

          <ContainerContent>
            <Text size={24} weight="700" color={colors.black}>
              Conta recusada
            </Text>
            <Text size={14} weight="400" color={colors.gray}>
              Não conseguimos validar seus dados, entre em contato com nossa
              equipe de atendimento.
            </Text>
          </ContainerContent>
          <ContainerButton>
            <Button
              aria-label="btn-voltar"
              fullWidth
              color={colors.white}
              fontColor={colors.green}
              style={{ width: '45%', border: `1px solid ${colors.green}` }}
              onClick={() => {
                setOpenModalContaRejeitada(false)
                openModalSelectCnpj()
              }}
            >
              Voltar
            </Button>
            <Button
              aria-label="btn-central-atendimento"
              style={{ width: '45%' }}
              fullWidth
              color={colors.green}
              onClick={() => {
                history.push('/fale-conosco')
              }}
            >
              Central de atendimento
            </Button>
          </ContainerButton>
        </Container>
      </StyledModal>
    </>
  )
}

export default memo(ModalContaRejeitada)
